import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { StyledChatContainer, StyledChatHeader, StyledChatFooter, StyledChatWrapper, StyledChatContent, StyledChatWidgets } from './GlobalChat.styled';
import ChatCloseImage from "../../assets/images/chat-close.png"
import ChatInfoImage from "../../assets/images/info.svg"
import SendChatIcon from "../../assets/images/send-chat.png";
import Input from '../Input/Input';
import { socket } from '../../server/socket';
import { IGlobalMessage, SocketEmit, SocketOn } from '../../types.ds';
import { game } from '../../store/game';
import { PlayerContext } from '../../contexts/playerContext';
import { MessageForm } from '../ModalsManager/Chat/Chat.styled';
import { observer } from 'mobx-react-lite';
import ProfileImage from "../../assets/images/profile-icon.png"

interface Props {
    chatOpen: boolean
    setChatOpen: (status: boolean) => void
    modalActive: string
    setModalActive: (active: string) => void
}

const GlobalChat = observer((props: Props) => {
    const playerContext = useContext(PlayerContext);
    const [chatValue, setChatValue] = useState<string>('');
    const messagesEndRef = useRef<HTMLDivElement>(null);
    const messages = game.globalChat?.messages ?? [];

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (chatValue.length) {
            const newMessage: IGlobalMessage = {
                id: '',
                text: chatValue.split('\n'),
                playerId: playerContext?.playerId ?? '',
                playerName: playerContext?.playerName ?? '',
                playerAvatar: playerContext?.avatar ?? '',
                time: '',
            };

            game.emit[SocketEmit.GlobalChatSendMessage](JSON.stringify(newMessage));
            setChatValue('');
        }
    };

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages.length]);

    useEffect(() => {
        socket.on(SocketOn.GlobalChatServerMessage, () => {
            setChatValue('');
        });
    }, [messages.length]);

    return (
        <StyledChatContainer chatOpen={props.chatOpen}>
            <StyledChatHeader>
                <img src={ChatInfoImage} alt="chat info" width={35} height={35} onClick={() => props.setModalActive("active")} style={{ cursor: "pointer", marginRight: '10px' }} />
                <img src={ChatCloseImage} alt="close chat" width={35} height={35} onClick={() => props.setChatOpen(false)} style={{ cursor: "pointer" }} />
            </StyledChatHeader>
            <StyledChatWidgets>
                {messages.map((message, index) => (
                    <StyledChatWrapper key={index}>
                        <img src={`${message.playerAvatar == "" ? ProfileImage : process.env.REACT_APP_API_ENDPOINT + message.playerAvatar}`} width={80} height={80} style={{ borderRadius: "100%", margin: '0 10px' }} alt="player avatar" crossOrigin="anonymous" />
                        <div className='chat_content'>
                            <h3 style={{ margin: '0', color: 'rgb(69, 203, 57)', fontSize: 14 }}>{message.playerName}</h3>
                            <StyledChatContent style={{ margin: '0', marginTop: '10px', color: 'white' }}>{message.text}</StyledChatContent>
                        </div>
                    </StyledChatWrapper>
                ))}
                <div ref={messagesEndRef} />
            </StyledChatWidgets>
            <StyledChatFooter>
                {
                    playerContext?.wallet.connected ? (
                        <MessageForm
                            onSubmit={handleSubmit}
                            onClick={(e) => e.stopPropagation()}
                            className="message-form"
                            style={{ marginTop: 'unset' }}
                        >
                            <Input width={"100%"} value={chatValue} event={(e) => setChatValue(e.target.value)} />
                            <button type="submit" style={{ backgroundColor: 'rgba(0 ,0, 0, 0)', border: 'none' }} disabled={!chatValue.length}><img src={SendChatIcon} alt="send chat" width={25} height={25} style={{ cursor: "pointer" }} /></button>
                        </MessageForm>
                    )
                        :
                        (
                            <p>Connect Wallet</p>
                        )
                }

            </StyledChatFooter>
        </StyledChatContainer>
    );
})

export default GlobalChat;
